module.exports = __webpack_public_path__ + "static/media/website-header-small.39f8ce9c.jpg";